declare namespace $ {

	type $mol_dimmer__haystack_bog_vmap_app_palette_port_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette_port['body'] >
		,
		ReturnType< $mol_dimmer['haystack'] >
	>
	type $mol_dimmer__needle_bog_vmap_app_palette_port_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_palette_port['needle'] >
		,
		ReturnType< $mol_dimmer['needle'] >
	>
	export class $bog_vmap_app_palette_port extends $mol_form_field {
		Body( ): $mol_dimmer
		sign( ): string
		body( ): string
		owner( ): string
		needle( ): string
		name( ): ReturnType< $bog_vmap_app_palette_port['sign'] >
		bids( ): readonly(any)[]
		control( ): ReturnType< $bog_vmap_app_palette_port['Body'] >
	}
	
}

//# sourceMappingURL=port.view.tree.d.ts.map